import "./vuetify";
import i18n from "../i18n";

var AJAX_BASE_URL = "/api/";
("#if TARGET === 'development'");
AJAX_BASE_URL = "http://localhost:8090/api/";
("#endif");
"#if TARGET === 'locale'"
AJAX_BASE_URL = "https://localhost:44307/api/";
"#endif"

var VueURLPlugin = {};

VueURLPlugin.install = function(Vue /*, options*/) {
  Vue.$url = function(url) {
    return AJAX_BASE_URL + url;
  };

  Vue.$href = function(url) {
    let qs = "";
    if (Vue.$auth_token) {
      qs = `?auth=${Vue.$auth_token}`;
    }
    return AJAX_BASE_URL + url + qs;
  };

  Vue.$hrefWithParams = function(url) {
    let qs = "";
    if (Vue.$auth_token) {
      qs = `&auth=${Vue.$auth_token}`;
    }
    return AJAX_BASE_URL + url + qs;
  };

  // CALLED BY LOGIN / LOGOUT MUTATIONS
  Vue.$auth = function(auth) {
    Vue.$auth_token = auth;
  };

  Vue.$logout = function() {
    Vue.$auth_token = undefined;
  };

  Vue.$err = function(eobj, objtype) {
    this.$log.debug("OBJTYPE:", objtype);
    this.$log.debug("EOBJ:", eobj);
    this.$log.debug("ajax error!");
    if (eobj && typeof eobj === "object") {
      if (eobj.err && eobj.objtype) {
        eobj = eobj.err;
        objtype = eobj.objtype;
      }

      if (objtype) objtype = i18n.t(objtype);
      this.$log.debug("ajax error: ", eobj);

      if (eobj.response) {
        // ajax / http error
        this.$log.debug("axios error: ", eobj.response);

        // axios error
        if (eobj.response.status === 404) {
          return i18n.t("err.not-found", { objtype });
        }

        if (eobj.response.status >= 500 && eobj.response.status <= 599) {
          return i18n.t("err.internal-error");
        }

        if (eobj.response.status == 422) {
          // this should be "dead code", because (normally) it's never
          // reached by the axios "default" error handling
          return i18n.t("err.unprocessable-entity");
        }
      }
    }

    if (eobj && typeof eobj === "string") {
      return i18n.t(eobj);
    }

    return null;
  };
};

export default VueURLPlugin;
